import Tribute from 'tributejs'

const findMentionsAreasOnPage = () => {
  const fields = $('.js-mentions')

  if (fields.length > 0) {
    fields.each((_index, field) => {
      initializeTribute(field)
    })
  }
}

window.findMentionsAreasOnPage = findMentionsAreasOnPage

const pasteHtml = (elementEditor) => (
  (html, startPos, endPos) => {
    let position = elementEditor.editor.getPosition()
    let tributeLength = endPos - startPos
    let trixStartPos = position - tributeLength
    let trixEndPos = position
    elementEditor.editor.setSelectedRange([trixStartPos, trixEndPos])
    elementEditor.editor.deleteInDirection('backward')
  }
)

const replaced = (elementEditor) => (
  (event) => {
    let mention = event.detail.item.original
    elementEditor.editor.insertString(mention.key)
  }
)

const insertIntoTextarea = (textarea, mention) => {
  let cursorPos = $(textarea).prop('selectionStart')
  let value = $(textarea).val()
  let textBefore = value.substring(0,  cursorPos)
  let textAfter  = value.substring(cursorPos, value.length)

  $(textarea).val(textBefore + mention.key + textAfter)
}

const initializeTribute = (elementEditor) => {
  let mentionsVariables = JSON.parse(elementEditor.dataset.mentions)

  let tribute = new Tribute({
    allowSpaces: true,
    lookup: 'key',
    trigger: '[',
    allowSpaces: false,
    selectTemplate: function (item) {
      return '[' + item.original.value.substring(1)
    },
    values: mentionsVariables.map((elem) => ({key: elem, value: elem}))
  })

  tribute.attach(elementEditor)
  tribute.range.pasteHtml = pasteHtml(elementEditor)
  if (elementEditor.tagName === 'TRIX-EDITOR') {
    elementEditor.addEventListener('tribute-replaced', replaced(elementEditor))
  }
}

$(document).ready(findMentionsAreasOnPage)
